export default __webpack_public_path__ + "static/flip-a8b6b17d9f9b6f5fa58b0349fb7a82dd.png";